import { axiosPrivate } from 'app/utils';
import helpers from './helpers';

export default {
  async searchServiceCatalog(serviceName) {
    const response = await axiosPrivate.get(`/services/catalog/search?service_name=${serviceName}`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getCatalogService(serviceId) {
    const response = await axiosPrivate.get(`/services/catalog/${serviceId}`);

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async getSuggestedServices(pharmacyId) {
    const response = await axiosPrivate.get(
      `/services/catalog/suggestions?pharmacy_id=${pharmacyId}`
    );

    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
